import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	addIssueType: {
		id: 'admin-pages-issue-types-directory.header-actions.add-issue-type',
		defaultMessage: 'Add issue type',
		description: 'Button label for button to add a new issue type',
	},
});
